export default __webpack_public_path__ + "a1173f4bc74e1b8c2fd984ffdd67f3ed.svg";